module.exports = __webpack_public_path__ + "static/img/1_1_3.b61260e6.jpg";